import React, { useEffect, useState } from 'react'
import { HeaderReferral } from '../../../components/Header/HeaderReferral'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link } from 'react-router-dom'

export const AddReferral = () => {
  toast.configure()

  // fetch email and user name from localstorage
  const userEmail = localStorage.getItem('email')
  const userName = localStorage.getItem('user')

  // set state of input values
  const [values, setValues] = useState({
    candidateName: '',
    candidateResume: '',
    desgination: '',
    candidateExperience: '',
    candidateLinkedin: '',
  })

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  // func to getpositions
  const [position, setPosition] = useState([])

  const getvalues = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchPositions')
      .then((res) => {
        setPosition(res.data.data)
      })
      .catch((error) => {})
  }
  useEffect(() => {
    getvalues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // to submit reuqest for refering friend
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'referral/newReferral', {
        candidate_name: values.candidateName,
        designation: values.desgination,
        relevant_it_experience: values.candidateExperience,
        candidate_linkedin: values.candidateLinkedin,
        candidate_resume: values.candidateResume,
        referred_by: userName,
        referral_email: userEmail,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })

        // after success clear input values
        setValues({
          candidateName: '',
          candidateResume: '',
          desgination: '',
          candidateExperience: '',
          candidateLinkedin: '',
        })
      })
      .catch((err) => {
        toast.error(err.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }

  return (
    <div className="container p-3">
      <HeaderReferral />
      <div className="w-100 d-flex">
        <div className="container mt-4">
          <div className="d-flex justify-content-between w-100 mb-4">
            <h4 className="text-primary">Refere A Friend !</h4>
            <Link to="/view-referral" className="link">
              <button className="btn btn-outline-primary btn-sm">
                View My Referrals
              </button>
            </Link>
          </div>
          <div className="card w-100 p-5">
            <form onSubmit={postData}>
              <div className="details d-flex justify-content-start flex-column">
                <h6 className="border-bottom w-100 text-start">
                  Employee Details
                </h6>
                <div className="row mt-2">
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted"
                      style={{ fontSize: '14px', fontWeight: 600 }}
                    >
                      Employee Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={userName}
                      name="empName"
                      required
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted"
                      style={{ fontSize: '14px', fontWeight: 600 }}
                    >
                      Email address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={userEmail}
                      name="empEmail"
                      required
                      readOnly
                    />
                  </div>
                </div>
                <h6 className="border-bottom w-100 text-start mt-3">
                  Candidate Details
                </h6>
                <div className="row mt-2">
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted"
                      style={{ fontSize: '14px', fontWeight: 600 }}
                    >
                      Candidate Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      name="candidateName"
                      onChange={handleChange}
                      value={values.candidateName}
                      required
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted"
                      style={{ fontSize: '14px', fontWeight: 600 }}
                    >
                      Designation
                    </label>
                    <select
                      className="form-select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      name="desgination"
                      onChange={handleChange}
                      value={values.desgination}
                      required
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      {position?.map((i, index) => {
                        return (
                          <option value={i.value} key={index}>
                            {i.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted "
                      style={{ fontSize: '14px', fontWeight: 600 }}
                    >
                      Total Experience
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      required
                      name="candidateExperience"
                      onChange={handleChange}
                      value={values.candidateExperience}
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted"
                      style={{ fontSize: '14px', fontWeight: 600 }}
                      required
                    >
                      Linkedin Profile
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      name="candidateLinkedin"
                      onChange={handleChange}
                      value={values.candidateLinkedin}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="mb-3 col-md">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label text-start w-100 text-muted"
                      style={{ fontSize: '14px', fontWeight: 600 }}
                      required
                    >
                      Resume/CV
                    </label>
                    <span
                      className="text-primary d-flex justify-content-start"
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        // marginRight: '2.5rem',
                      }}
                    >
                      Please upload the resume/cv on drive and provide the link
                      below.
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      name="candidateResume"
                      onChange={handleChange}
                      value={values.candidateResume}
                    />
                  </div>
                </div>
                <div>
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
